import * as actionTypes from '../../actions/actionTypes';

const initialState = {
    personalGroupInfo: [],
    loadingPersonalGroupInfo: false
};

const loadPersonalGroupInfo = (state) => {
    return {
        ...state,
        loadingPersonalGroupInfo: true
    }
}

const setPersonalGroupInfo = ( state, action ) => {
    let tmp = {...action.personalGroupInfo}
    return {
        ...state,
        personalGroupInfo: tmp,
        loadingPersonalGroupInfo: false
    }
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.LOAD_PERSONAL_GROUP_INFO: return loadPersonalGroupInfo( state );
        case actionTypes.SET_PERSONAL_GROUP_INFO: return setPersonalGroupInfo( state, action );
        default: return state;
    }
};
export default reducer;